import script from "./RightPie.vue?vue&type=script&setup=true&lang=js"
export * from "./RightPie.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__